import { render, staticRenderFns } from "./indexNewNew.vue?vue&type=template&id=25d21ba0&scoped=true"
import script from "./indexNewNew.vue?vue&type=script&lang=js"
export * from "./indexNewNew.vue?vue&type=script&lang=js"
import style0 from "./indexNewNew.vue?vue&type=style&index=0&id=25d21ba0&prod&lang=scss&scoped=true"
import style1 from "./indexNewNew.vue?vue&type=style&index=1&id=25d21ba0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d21ba0",
  null
  
)

export default component.exports